// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.chi .chi-table.-portal.-sm td[data-v-ab7d63c0],\n.chi .chi-table.-portal.-sm th[data-v-ab7d63c0] {\n  padding: 0.25rem;\n}\n.chi .chi-card__content[data-v-ab7d63c0] {\n  padding: 0.5rem;\n}\n", ""]);
// Exports
module.exports = exports;
